<template>
  <div
    class="flex justify-center rounded-lg relative min-h-screen bg-gradient-to-b from-gray-900 to-black p-2 sm:p-4"
  >
    <div class="w-full max-w-md md:max-w-lg lg:max-w-xl">
      <div class="relative mt-3 z-50">
        <div class="">
          <landing-language-switcher />
        </div>
      </div>

      <div
        class="container mx-auto px-3 sm:px-4 md:px-6 py-4 sm:py-6 md:py-8 bg-sub shadow-md drop-shadow-2xl rounded-md relative"
      >
        <!-- Carousel Section -->
        <div class="mb-4 sm:mb-6">
          <LPCarsoul class="rounded-lg" />
        </div>
        <div class="mb-4 sm:mb-6">
          <landing-service-name />
        </div>

        <div
          class="mb-4 sm:mb-6 text-[#CB34C5] text-center text-sm sm:text-base font-semibold"
        >
          <p v-if="authStore.getLandingPageLanguage == 'ar'">
            أنت على وشك الاشتراك في خدمة المحتوى
          </p>
          <p v-if="authStore.getLandingPageLanguage == 'en'">
            You are about to subscribe to content services
          </p>
        </div>

        <!-- Price Dropdown -->
        <div class="flex flex-col items-center mb-4 sm:mb-6 w-full relative z-50">
          <label class="text-white mb-2 text-sm sm:text-base font-semibold">
            <template v-if="authStore.getLandingPageLanguage == 'en'">
              Choose your plan
            </template>
            <template v-if="authStore.getLandingPageLanguage == 'ar'">
              اختر الباقة
            </template>
          </label>
          <select
            v-model="isSelected"
            @change="updateSelectedPrice"
            class="bg-gray-900 border border-[#CB34C5] text-white text-sm sm:text-base rounded-md px-3 sm:px-4 py-2 sm:py-3 focus:ring-[#CB34C5] focus:border-[#CB34C5] w-full max-w-md transition-all duration-200"
          >
            <option value="" disabled>
              <template v-if="authStore.getLandingPageLanguage == 'en'">
                Select a plan
              </template>
              <template v-if="authStore.getLandingPageLanguage == 'ar'">
                اختر باقة
              </template>
            </option>
            <option
              v-for="price in prices"
              :key="price.metadata.name"
              :value="price.metadata.name"
            >
              {{ getTitle(price.metadata) }} - {{ price.metadata.price }}
              {{ getCurrency(price.metadata) }}
            </option>
          </select>
        </div>

        <!-- Phone Number Input -->
        <div class="flex flex-col items-center mb-4 sm:mb-6 w-full">
          <label class="text-white mb-2 text-sm sm:text-base font-semibold">
            <template v-if="authStore.getLandingPageLanguage == 'en'">
              Phone Number
            </template>
            <template v-if="authStore.getLandingPageLanguage == 'ar'">
              رقم الجوال
            </template>
          </label>
          <div class="relative w-full max-w-md">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-4 w-4 sm:h-5 sm:w-5 absolute left-3 top-1/2 transform -translate-y-1/2 z-10"
              fill="none"
              viewBox="0 0 24 24"
              stroke="white"
              stroke-width="1"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
              />
            </svg>

            <input
              dir="ltr"
              type="number"
              class="bg-gray-900 border border-[#CB34C5] focus:ring-[#CB34C5] focus:border-[#CB34C5] text-white text-sm sm:text-base rounded-md w-full px-3 sm:px-4 py-2 sm:py-3 pl-8 sm:pl-10 transition-all duration-200"
              v-model="phone"
              @keypress="acceptNumbersOnly($event)"
              @input="handlePhoneInput"
              @focus="chechkPhone"
              maxlength="12"
              :placeholder="
                authStore.getLandingPageLanguage == 'en'
                  ? 'Enter STC number (9665xxxxxxxx)'
                  : 'ادخل رقم STC (9665xxxxxxxx)'
              "
              required
            />
          </div>
        </div>

        <!-- Error Message -->
        <div v-if="error" class="mb-4 sm:mb-6">
          <p class="text-red-400 text-center text-sm sm:text-base px-2">
            {{ message }}
          </p>
        </div>

        <!-- Action Buttons -->
        <div
          class="flex flex-col sm:flex-row justify-center gap-3 sm:gap-4 w-full max-w-md mx-auto mb-4 sm:mb-6 relative z-50"
        >
          <button
            type="button"
            :disabled="isLoading"
            :class="[
              'flex justify-center items-center text-white focus:ring-0 focus:outline-none focus:ring-[#CB34C5] rounded-lg text-sm sm:text-base px-4 sm:px-6 py-3 sm:py-4 bg-[#CB34C5] cursor-pointer transition-all duration-200 font-semibold AFsubmitbtn',
              'w-full sm:flex-1',
              isLoading
                ? 'cursor-not-allowed opacity-60'
                : 'hover:bg-[#a0269e] transform hover:scale-105',
            ]"
            @click="subscribe"
            id="confirm_otp"
          >
            <template v-if="authStore.getLandingPageLanguage == 'en'">
              Subscribe Now!
            </template>
            <template v-if="authStore.getLandingPageLanguage == 'ar'">
              إشترك الآن
            </template>

            <div role="status" v-show="isLoading" class="ml-2">
              <!-- spinner SVG -->
            </div>
          </button>
          <button
            type="button"
            class="flex justify-center items-center text-white focus:ring-0 focus:outline-none focus:ring-[#CB34C5] rounded-lg text-sm sm:text-base px-4 sm:px-6 py-3 sm:py-4 border border-gray-400 cursor-pointer bg-gray-800 hover:bg-gray-700 transition-all duration-200 font-semibold w-full sm:flex-1 hover:border-gray-300"
            @click="$router.push('/')"
          >
            <template v-if="authStore.getLandingPageLanguage == 'en'"> Exit </template>
            <template v-if="authStore.getLandingPageLanguage == 'ar'"> خروج </template>
          </button>
        </div>

        <!-- Disclaimers -->
        <div class="flex justify-center text-center text-[#a0269e]">
          <span class="text-xs relative z-50 px-2 text-[#a0269e]">
            <template v-if="authStore.getLandingPageLanguage == 'en'">
              This service is available to Saudi Telecom Company customers for
              {{ prices[isSelected === "daily" ? 0 : 1].metadata.price }} SAR for prepaid
              customers,
              {{ prices[isSelected === "daily" ? 0 : 1].metadata.interval_en }} (excluding
              VAT), and for
              {{ prices[isSelected === "daily" ? 0 : 1].metadata.postPaidPrice }} SAR for
              postpaid customers, renewed monthly (including VAT). To cancel your
              subscription, please send {{ '"'
              }}{{ prices[isSelected === "daily" ? 0 : 1].metadata.unsub_keyword_en
              }}{{ '"' }} to 802621. The tax amount is collected from prepaid customers
              upon recharging.
            </template>
            <template v-if="authStore.getLandingPageLanguage == 'ar'">
              هذه الخدمة متوفرة لعملاء شركة الاتصالات السعودية مقابل
              {{ prices[isSelected === "daily" ? 0 : 1].metadata.price }} ريال لعملاء مسبق
              الدفع  {{ prices[isSelected === "daily" ? 0 : 1].metadata.interval_ar }} و بمقابل
              {{ prices[isSelected === "daily" ? 0 : 1].metadata.postPaidPrice }} ريال
              لعملاء المفوتر تتجدد شهرياً (شامل قيمة الضريبة المضافة) ولإلغاء الاشتراك
              الرجاء ارسال {{ '"'
              }}{{ prices[isSelected === "daily" ? 0 : 1].metadata.unsub_keyword_ar
              }}{{ '"' }} الى
              {{"802621"}}. تم تحصيل
              مبلغ الضريبة المضافة لعملاء مسبق الدفع عند عملية شحن الرصيد
            </template>
          </span>
        </div>

        <!-- Login Link -->
        <div class="flex justify-center text-center my-2">
          <span class="text-white text-xs sm:text-sm md:text-base relative z-50 px-2">
            <template v-if="authStore.getLandingPageLanguage == 'en'">
              Already have an active subscription?
              <a
                href="/login"
                class="text-color hover:text-[#a0269e] transition-colors duration-200 font-semibold"
              >
                Login
              </a>
            </template>
            <template v-if="authStore.getLandingPageLanguage == 'ar'">
              لديك اشتراك نشط بالفعل؟
              <a
                href="/login"
                class="text-color hover:text-[#a0269e] transition-colors duration-200 font-semibold"
              >
                تسجيل الدخول
              </a>
            </template>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { validateStcPhone } from "@/util/validation";
import { useAuthStore } from "@/stores/auth";
import { mapActions } from "pinia";
import LPCarsoul from "@/components/shared/LPCarsoul.vue";
import { useToast } from "vue-toastification";
import LandingLanguageSwitcher from "@/components/landingpage/LandingLanguageSwitcher.vue";
import { AF } from "@/constants";
import LandingServiceName from "@/components/landingpage/LandingServiceName.vue";

export default {
  components: {
    LPCarsoul,
    LandingLanguageSwitcher,
    LandingServiceName,
  },
  data() {
    return {
      phone: "966050xxxxxxx",
      error: false,
      isLoading: false,
      show: false,
      message: "",
      bgColor: "bg-green-600",
      authStore: useAuthStore(),
      toast: useToast(),
      unsub_keyword: "U KW",
      // Prices dropdown
      prices: [
        {
          metadata: {
            name: "daily",
            title_ar: "يومياً",
            title: "Daily",
            price: 2,
            currency_ar: "ريال",
            currency_en: "SAR",
            unsub_keyword_en: "U 1",
            unsub_keyword_ar: "غ 1",
            short_code: "802621",
            postPaidPrice: 69,
            interval_en: "renewed daily",
            interval_ar: "(تجدد يومياً)",
          },
        },
        {
          metadata: {
            name: "weekly",
            title_ar: "أسبوعياً",
            title: "Weekly",
            price: 5,
            currency_ar: "ريال",
            currency_en: "SAR",
            unsub_keyword_en: "U 2",
            unsub_keyword_ar: "غ 2",
            short_code: "802621",
            postPaidPrice: 23,
            interval_ar: "(تجدد اسبوعياً)",
            interval_en: "renewed weekly",
          },
        },
      ],
      isSelected: "daily",
    };
  },
  watch: {
    async phone(newValue, oldValue) {
      if (newValue.length < 3) this.phone = "966";
      if (isNaN(newValue)) this.phone = oldValue;
    },
  },
  methods: {
    ...mapActions(useAuthStore, ["callAntifraudAPI", "callOtpAPI"]),
    getTitle(title) {
      return this.authStore.getLandingPageLanguage === "ar"
        ? title.title_ar
        : title.title;
    },
    getCurrency(title) {
      return this.authStore.getLandingPageLanguage === "ar"
        ? title.currency_ar
        : title.currency_en;
    },
    selectPlan(name) {
      this.isSelected = name;
     
    },
    updateSelectedPrice() {
      localStorage.setItem("selectedPrice", this.isSelected);
      // Inject antifraud script when package is selected
      this.injectAntifraudScript(this.isSelected);
      // Call subscribe API when package is changed (if phone is ready)
    },

    async callSubscribeAPI() {
      // Check if phone number is complete and valid for STC
      const phoneStr = this.phone.toString().trim();

      // Only proceed if we have a complete phone number (not placeholder)
      if (phoneStr.includes("x") || phoneStr === "966" || phoneStr.length < 12) {
        return; // Phone not complete yet
      }

      // Check for proper length based on format
      if (phoneStr.startsWith("966")) {
        // International format should be exactly 12 digits
        if (phoneStr.length !== 12) return;
      } else if (phoneStr.startsWith("0")) {
        // Local format with 0 should be exactly 10 digits
        if (phoneStr.length !== 10) return;
      } else {
        // Local format without 0 should be exactly 9 digits
        if (phoneStr.length !== 9) return;
      }

      // Only call API if we have a valid STC phone number
      if (!validateStcPhone(phoneStr).valid) {
        this.toast.error("يرجى إدخال رقم STC صحيح (50, 53, 55, 58, 59)");
        return;
      }

      if (!this.isSelected) {
        this.toast.error("اختر الباقة المناسبة");
        return;
      }
    
      try {
        this.isLoading = true;
        const packageName = localStorage.getItem("selectedPrice");
        const referenceUserId = this.$route.query.referenceUserId || null;
        const response = await this.callOtpAPI(
          validateStcPhone(phoneStr).phoneNumber,
          packageName,
          referenceUserId
        );

        if (response.data.success) {
          // Redirect to payment gateway
          window.location.href = response.data.url;
        } else {
          
          this.isLoading = false;
          this.toast.error(
            response.data.message || "فشل في الاشتراك، يرجى المحاولة مرة أخرى"
          );
          this.isLoading = false;
        }
      } catch (error) {
        this.isLoading = false;
        this.toast.error("حدث خطأ، يرجى المحاولة مرة أخرى");
        console.error("Subscribe API error:", error);
      }
    },

    async injectAntifraudScript(packageName) {
      // First, remove any existing antifraud scripts
      this.removeExistingAntifraudScripts();

      // Use a global flag to prevent multiple calls across component recreations
      if (!window.antifraudScriptProcessing) {
        window.antifraudScriptProcessing = true; // Set global flag immediately

        if (process.env.NODE_ENV === "development") {
          console.log("Antifraud script injection started for package:", packageName);
        }
        try {
          console.log("Calling antifraud API for package:", packageName);
          const response = await this.callAntifraudAPI(packageName);

          // Check if response exists and has the expected structure
          if (!response) {
            throw new Error("API response is undefined");
          }

          if (!response.data) {
            throw new Error("API response.data is undefined");
          }

          if (response.data.success && response.data.data) {
            window.localStorage.setItem(AF, response.data.data.AntiFrauduniqid);

            // Dynamically add the script tag to the <head>
            const scriptTag = document.createElement("script");
            scriptTag.type = "text/javascript";
            scriptTag.text = response.data.data.script;
            scriptTag.setAttribute("data-id", `antifraud-${packageName}`);
            document.head.appendChild(scriptTag);

            // Manually trigger DCBprotect execution since DOMContentLoaded has already fired
            const ev = new Event("DCBProtectRun");
            document.dispatchEvent(ev);

            if (process.env.NODE_ENV === "development") {
              console.log(
                `antifraud script for ${packageName} injected successfully to head and manually triggered`
              );
            }
          } else {
            throw new Error("API returned success: false or missing data");
          }
        } catch (error) {
          console.error("Failed to inject antifraud script:", error);
          window.antifraudScriptProcessing = false; // Reset flag on error
        } finally {
          window.antifraudScriptProcessing = false; // Reset flag when done
        }
      } else {
        if (process.env.NODE_ENV === "development") {
          console.log("antifraud script processing is already in progress");
        }
      }
    },

    removeExistingAntifraudScripts() {
      // Remove all existing antifraud scripts
      const existingScripts = document.querySelectorAll('script[data-id^="antifraud-"]');
      existingScripts.forEach((script) => {
        if (process.env.NODE_ENV === "development") {
          console.log(
            "Removing existing antifraud script:",
            script.getAttribute("data-id")
          );
        }
        script.remove();
      });

      // Also remove any legacy antifraud scripts without package name
      const legacyScript = document.querySelector('script[data-id="antifraud"]');
      if (legacyScript) {
        if (process.env.NODE_ENV === "development") {
          console.log("Removing legacy antifraud script");
        }
        legacyScript.remove();
      }
    },

    redirectUserToProvider() {
      if (!this.isSelected) {
        this.toast.error("اختر الباقة المناسبة");
        return;
      }
      localStorage.setItem("selectedPrice", this.isSelected);
    },
    handlePhoneInput(event) {
      let value = event.target.value.replace(/\D/g, ""); // Remove non-digits

      // Apply length restrictions based on format
      if (value.startsWith("966")) {
        // International format: 966 + 9 digits = 12 total
        if (value.length > 12) {
          value = value.substring(0, 12);
        }
      } else if (value.startsWith("0")) {
        // Local format with 0: 0 + 9 digits = 10 total
        if (value.length > 10) {
          value = value.substring(0, 10);
        }
      } else {
        // Local format without 0: 9 digits max
        if (value.length > 9) {
          value = value.substring(0, 9);
        }
      }

      // Update the phone value
      this.phone = value;

      // Update the input field value to reflect the trimmed value
      event.target.value = value;
    },

    acceptNumbersOnly(event) {
      var numberRegex = /^(?:-(?:[1-9](?:\d{0,2}(?:,\d{3})+|\d*))|(?:0|(?:[1-9](?:\d{0,2}(?:,\d{3})+|\d*))))(?:.\d+|)$/;
      if (numberRegex.test(event.target.value)) {
        return true;
      } else {
        event.preventDefault();
      }
    },
    chechkPhone(event) {
      // On focus, if the phone is the placeholder, set it to only Saudi country code
      if (this.phone === "966050xxxxxxx" || this.phone.includes("x")) {
        this.phone = "966";
        return this.phone;
      }

      // Remove any formatting and keep only numbers
      let cleanPhone = event.target.value.replace(/\D/g, "");

      // Prevent phone numbers longer than 12 digits (966 + 9 digits)
      if (cleanPhone.length > 12) {
        cleanPhone = cleanPhone.substring(0, 12);
      }

      // Handle different STC number formats
      if (cleanPhone.startsWith("966")) {
        // Keep full international format - max 12 digits
        this.phone = cleanPhone;
      } else if (cleanPhone.startsWith("0")) {
        // Local format starting with 0 - max 10 digits
        if (cleanPhone.length > 10) {
          cleanPhone = cleanPhone.substring(0, 10);
        }
        this.phone = cleanPhone;
      } else if (cleanPhone.length <= 9 && !cleanPhone.startsWith("0")) {
        // Format without leading 0 - max 9 digits
        if (cleanPhone.length > 9) {
          cleanPhone = cleanPhone.substring(0, 9);
        }
        this.phone = cleanPhone;
      } else {
        this.phone = cleanPhone;
      }

      return this.phone;
    },
    async subscribe() {
      // This method is now mainly a fallback for the manual subscribe button
      await this.callSubscribeAPI();
    },

    close() {
      return (this.error = false);
    },
    cancel() {
      this.$router.push({ name: "home" });
    },
  },
  beforeUnmount() {
    // Clean up all antifraud scripts when component is destroyed
    this.removeExistingAntifraudScripts();
    // Reset global flag
    window.antifraudScriptProcessing = false;
  },
  // For Vue 3 compatibility
  unmounted() {
    // Clean up all antifraud scripts when component is unmounted
    this.removeExistingAntifraudScripts();
    // Reset global flag
    window.antifraudScriptProcessing = false;
  },
  created() {
    this.injectAntifraudScript(this.isSelected);
    const origin = this.$route.query.origin || 'web';
    localStorage.setItem('origin', origin);
  },
};
</script>

<style scoped>
.width-height {
  width: 900px;
  height: auto;
}

.xxsm {
  width: 255px;
}

.w-btn {
  /* width: 290px; */
  align-self: right;
}

.btn-color {
  background-color: #9d2890;
}

.btn-color-disabled {
  background-color: #802e76;
}

.bg-sub {
  background-color: #181b30;
}

input {
  text-align: center;
  outline: none;
  padding-left: 5px;
  color: aliceblue;
}

::-webkit-input-placeholder {
  text-align: center;
}

:-moz-placeholder {
  text-align: center;
}

.font-small {
  font-size: 16px;
}
</style>
